import {Resource} from '@raison/types';
import React from 'react';
import {useSelector} from 'react-redux';
import {Navigate} from 'react-router';
import {RsnTabs} from '~/library/ui-kit';
import {groupBy} from '~/processes/dashboard/CurrencySelectionPage/utils';
import {AccountsGroupedByProvider} from '~/processes/dashboard/components/AccountsGroupedByProvider';
import ListLayout from '~/shared/layouts/ListLayout/ListLayout';
import {useAppDispatch} from '~/shared/store';
import {For, Layout, LayoutProps, LoadingScreen, Option, renderEmptyTab} from './components';
import {TradeOptionView} from './interfaces';

interface TradePageProps extends LayoutProps {
    selectOperations: (state: AppModel) => Resource<TradeOptionView[]>;
}

export function TradeCurrencySelectionPage({selectOperations: selectOptions, ...props}: TradePageProps) {
    const resource = useSelector(selectOptions);
    const dispatch = useAppDispatch();

    if (!resource.isSuccess) {
        return <LoadingScreen {...props} />;
    }

    const options = resource.data;
    if (options.length === 0) {
        return <Navigate replace to='/assets' />;
    }

    const {buy, sell, exchange} = groupBy(options, option => option.operationName);

    return (
        <Layout {...props}>
            <RsnTabs
                tabs={[
                    {
                        label: 'Exchange',
                        element: <AccountsGroupedByProvider data={exchange ?? []} />,
                    },
                    {
                        label: 'Buy',
                        element: (
                            <ListLayout>
                                <For each={buy} empty={renderEmptyTab()}>
                                    {op => (
                                        <Option key={op.shortName} {...op} onClick={() => dispatch(op.clickAction)} />
                                    )}
                                </For>
                            </ListLayout>
                        ),
                    },
                    {
                        label: 'Sell',
                        element: (
                            <ListLayout>
                                <For each={sell} empty={renderEmptyTab()}>
                                    {op => (
                                        <Option key={op.shortName} {...op} onClick={() => dispatch(op.clickAction)} />
                                    )}
                                </For>
                            </ListLayout>
                        ),
                    },
                ]}
            >
                <div className='p-4'>
                    <RsnTabs.Triggers />
                </div>
                <RsnTabs.Content />
            </RsnTabs>
        </Layout>
    );
}
